Monitoring.Views ||= {}

class AccountSettings.MarketingAccountListView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/dragable_list"]

  initialize: (@options = {}) ->
    @selections = []

  render: =>
    @$el.html(@template())
    @

  addNewSelection:(selectionView) =>
    existingAccounts = _.find @selections, (selection) -> selection.account.accountId == selectionView.account.accountId
    if existingAccounts
      swal("#{I18n.t('account_settings.topics.sources.error.repeated_account')}", "",  "error");
    else
      @selections.push(selectionView)
      selectionView.bind('selection:remove', @onRemoveSelection)
      @$el.find('.selections-list').append(selectionView.render().el)

  onRemoveSelection: (selectionView) =>
    @selections = _.without(@selections, selectionView)
    selectionView.remove()
